import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';

import { ScrollableTriggerDirective } from '@dmb/core';

import { NotificationCenterListComponent } from '../../../notification-center/list/notification-center-list.component';
import { SessionService } from '../../../services';
import { UserService } from '../../../user';
import { MenuService } from './menu.service';
import { NavHeaderComponent } from './nav-header/nav-header.component';
import { SubmenuItemComponent } from './submenu-item/submenu-item.component';
import { TopLevelComponent } from './top-level/top-level.component';

@Component({
  selector: 'dmb-combined-menu',
  templateUrl: './combined-menu.component.html',
  styleUrls: ['./combined-menu.component.scss'],
  imports: [
    NavHeaderComponent,
    NotificationCenterListComponent,
    TopLevelComponent,
    SubmenuItemComponent,
    ScrollableTriggerDirective,
  ],
  host: {
    '[class.collapsed]': 'collapsed()',
    '[class.active]': 'active()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CombinedMenuComponent {
  private userService = inject(UserService);
  private menuService = inject(MenuService);
  sessionService = inject(SessionService);

  collapsed = this.menuService.mainMenuCollapsed;
  active = computed(() => this.menuService.active() !== null);
  isImpersonated = this.sessionService.isImpersonated;
  logoutText = toSignal(
    this.userService.user.pipe(map((user) => $localize`:@@menu.logout:Log out` + '\xa0' + user.fullName)),
  );
  logoutIcon = toSignal(this.isImpersonated.pipe(map((v) => (v ? 'impersonate' : 'off'))), { initialValue: 'off' });

  hasUnreadNotifications = signal(false);

  public logout = () => {
    this.sessionService.logout();
  };

  backdropClicked() {
    this.menuService.setInactive();
  }
}
